import React from 'react'
import styled from 'styled-components'
import Button from 'components/lib/Button'

// Styled components

const Title = styled.p`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`

const Description = styled.p`
  font-size: 0.75rem;
  color: #555;
  margin-bottom: 0;
`

const Divider = styled.hr`
  margin-top: 10px;
  width: 100%;
  border: 0;
  opacity: 0.5;
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
`

const ExtraBillingHomeHeader = ({ onCreateBillingRequest }) => {
  return (
    <>
        <Row>
          <Column>
            <Title>Envio de cobrança</Title>
            <Description>
              Caso haja algum custo adicional por conta da imobiliária, utilize esta
              etapa para facilitar o envio de uma cobrança adicional ao inquilino.
            </Description>
          </Column>
          <Button
            hasThemeColor
            onClick={onCreateBillingRequest}
          >
            Nova cobrança
          </Button>
        </Row>
        <Divider />
    </>
  )
}

export default ExtraBillingHomeHeader
